const env = process.env.RAZZLE_NODE_ENV || process.env.NODE_ENV || 'development'
export const release = `${process.env.FS_CORE_ID || 'fs-core'}:${
  process.env.RAZZLE_RELEASE || require('../../../package.json').version
}`

export const semanticRelease = process.env.RAZZLE_SEMANTIC_RELEASE

export const isDev = env === 'development'
export const isProd = env === 'production'
export const isCi = process.env.CI && process.env.CI !== 'false'

const defaultCacheControl = 'private, no-store'
const defaultSurrogateControl = 'no-store'
export const environment = env

export const ingressType = process.env.INGRESS_TYPE

export const cacheControl = process.env.CACHE_CONTROL || defaultCacheControl
export const shortenedCacheControl = process.env.SHORTENED_CACHE_CONTROL || defaultCacheControl
export const assetsCacheControl = process.env.ASSETS_CACHE_CONTROL || defaultCacheControl
export const iconsCacheControl = process.env.ICONS_CACHE_CONTROL || defaultCacheControl
export const statusCacheControl = process.env.STATUS_CACHE_CONTROL || defaultCacheControl

export const surrogateControl = process.env.SURROGATE_CONTROL || defaultSurrogateControl
export const shortenedSurrogateControl =
  process.env.SHORTENED_SURROGATE_CONTROL || defaultSurrogateControl
export const assetsSurrogateControl =
  process.env.ASSETS_SURROGATE_CONTROL || defaultSurrogateControl
export const iconsSurrogateControl = process.env.ICONS_SURROGATE_CONTROL || defaultSurrogateControl
export const statusSurrogateControl =
  process.env.STATUS_SURROGATE_CONTROL || defaultSurrogateControl

export const surrogateKey = process.env.SURROGATE_KEY || 'content'
export const assetsSurrogateKey = process.env.ASSETS_SURROGATE_KEY || 'assets'
export const iconsSurrogateKey = process.env.ICONS_SURROGATE_KEY || 'assets icons'
export const clickTrackerSigningKey = process.env.CLICK_TRACKER_SIGNING_KEY

export const elasticSearchHost = process.env.ELASTIC_SEARCH_HOST

export const requiresAws = elasticSearchHost?.includes('amazonaws')

export const fsApiUrl = process.env.FS_API_URL || 'https://www.money.co.uk/api'
export const fsApiUrlInternal =
  process.env.FS_API_URL_INTERNAL ?? process.env.FS_API_URL ?? 'https://www.money.co.uk/api'

export const fsFrontOfficeUrlInternal =
  process.env.FS_FRONT_OFFICE_URL_INTERNAL ?? 'https://fs-front-office-production.external.usw.co'

export const apiHost = process.env.API_HOST || 'https://www.money.co.uk'

export const showDrafts = process.env.SHOW_DRAFTS === 'true'

export const forceHydration =
  process.env.RAZZLE_FORCE_HYDRATION === 'true'
    ? true
    : process.env.RAZZLE_FORCE_HYDRATION === 'false'
    ? false
    : isDev

export default env
